module.exports = __webpack_public_path__ + "img/Logomark.d281b0cb.svg";